<template>
  <div class="d-flex">
    <b-button
      :pressed="this.bold"
      :disabled="this.disabled"
      class="icon-btn"
      variant="outline-primary"
      @click.prevent="fontStyleClick('bold')"
    >
      <font-awesome-icon :icon="['fas', 'bold']" />
    </b-button>
    <b-button
      :pressed="this.italic"
      :disabled="this.disabled"
      class="icon-btn"
      variant="outline-primary"
      @click.prevent="fontStyleClick('italic')"
    >
      <font-awesome-icon :icon="['fas', 'italic']" />
    </b-button>
  </div>
</template>

<script>
import {ActionType} from './actionType'
export default {
  props: {
    isBold: {
      type: Boolean,
      default: false
    },
    isItalic: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      actionType: ActionType.FONT_STYLE,
      value: [],
      bold: false,
      italic: false
    }
  },
  created () {
    if (this.isBold && this.isItalic) {
      this.value = ['bold', 'italic']
    } else if (this.isBold) {
      this.value = ['bold']
    } else if (this.isItalic) {
      this.value = ['italic']
    }
    this.bold = this.isBold
    this.italic = this.isItalic
  },
  methods: {
    fontStyleClick (type) {
      switch (type) {
        case 'bold':
          this.bold = !this.bold
          if (this.bold) {
            this.value = [...new Set([...this.value, 'bold'])]
          } else {
            this.value = this.value.filter(el => el !== 'bold')
          }
          this.$emit('change', this.actionType, this.value.join(' '))
          break
        case 'italic':
          this.italic = !this.italic
          if (this.italic) {
            this.value = [...new Set([...this.value, 'italic'])]
          } else {
            this.value = this.value.filter(el => el !== 'italic')
          }
          this.$emit('change', this.actionType, this.value.join(' '))
          break
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/schemaFonctionnel/ui/fontStyleUI.vue